import watchGettingToKnowYouDraftRequested from './getGettingToKnowYouDraft';
import watchGettingToKnowYouRequested from './postGettingToKnowYou';

export default [
  watchGettingToKnowYouDraftRequested(),
  watchGettingToKnowYouRequested(),
];
